/** @module csi/dgrid/WidthMixin */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/html"
], function(declare, _, html) {

	/**
	 * Increase width of dgrid on startup so that it will include space to fit all columns.
	 */
	return declare(null, {
		startup: function() {
			if (this._started) {
				return;
			}

			this.inherited(arguments);

			const {domNode, headerNode, headerScrollNode} = this;
			const tableWidth = html.preciseWidth(headerNode.firstChild);
			const scrollerWidth = html.preciseWidth(headerScrollNode);

			// add 1 to width to make Firefox happy
			html.setPixels(domNode, html.WIDTH, tableWidth + scrollerWidth + 1);
		}
	});
});
